var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { getDirectParent } from '@lib/popups';
import { Select } from 'antd';
import React, { forwardRef } from 'react';
const activityPeriodOptions = [1, 3, 7, 30, 90]
    .map((period) => ({
    label: COPY_GENERIC.DAYS(period),
    value: period
}));
export const AppActivityPeriodSelect = forwardRef((_a, ref) => {
    var { allowClear, defaultValue, getPopupContainer, onChange } = _a, rest = __rest(_a, ["allowClear", "defaultValue", "getPopupContainer", "onChange"]);
    return React.createElement(Select, Object.assign({}, rest, { allowClear: allowClear, defaultValue: defaultValue, getPopupContainer: getPopupContainer !== null && getPopupContainer !== void 0 ? getPopupContainer : getDirectParent, onChange: onChange, options: activityPeriodOptions, ref: ref, showAction: ['focus', 'click'] }));
});
